module.exports = __webpack_public_path__ + "img/Ruins1.8769e728.png";